module.exports = __webpack_public_path__ + "img/ansvarsfullt.se.2ed2582e.png";